import { render, staticRenderFns } from "./WarningBubble.vue?vue&type=template&id=0389f50b&scoped=true&"
import script from "./WarningBubble.vue?vue&type=script&lang=js&"
export * from "./WarningBubble.vue?vue&type=script&lang=js&"
import style0 from "./WarningBubble.vue?vue&type=style&index=0&id=0389f50b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389f50b",
  null
  
)

export default component.exports